import { motion } from 'framer-motion';
import '../styles/AboutSnapshot.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

export default function AboutSnapshot() {
  return (
    <section className="section about-snapshot">
      <div className="container">
        <motion.div className="about__content" {...fadeUp(0)}>
          <div className="section__tag">About Us</div>
          <h2 className="section__title">Who We Are</h2>

          <div className="about__text-content">
            <p className="about__description about__description--primary">
              Kodefactor is a technology consulting and digital engineering company helping organizations innovate, modernize, and scale through AI-powered and cloud-driven solutions.
            </p>

            <p className="about__description about__description--primary">
              We combine strategy, engineering, and execution to solve complex business challenges and create long-term value for our clients.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
